//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
let d=[[[0,"CleanupAssemblyComponentPatterns",1,0],[0,"CleanupAssemblyConstraints",1,0],[0,"CleanupCAMObjects",1,0],[0,"CleanupDraftingObjects",1,0],[0,"CleanupFeatureData",1,0],[0,"CleanupMatingData",1,0],[0,"CleanupMotionData",1,0],[0,"CleanupPartFamilyData",1,0],[0,"CleanupRoutingData",1,0],[0,"DeleteBrokenInterpartLinks",1,0],[0,"DeleteCorruptAssemblyStructure",1,0],[0,"DeleteDuplicateLights",1,0],[0,"DeleteInvalidAttributes",1,0],[0,"DeleteMassProperties",1,0],[0,"DeleteMaterials",1,0],[0,"DeleteSpreadSheetData",1,0],[0,"DeleteUnusedExpressions",1,0],[0,"DeleteUnusedExtractReferences",1,0],[0,"DeleteUnusedFonts",1,0],[0,"DeleteUnusedObjects",1,0],[0,"DeleteUnusedUnits",1,0],[0,"DeleteVisualEditorData",1,0],[0,"FixOffplaneSketchCurves",1,0],[0,"GroupsToDelete",1,0],[0,"PartsToCleanup",1,0],[0,"ResetComponentDisplay",1,0],[0,"TurnOffHighlighting",1,0]],[[[],"Dispose",{},0,0],[[],"DoCleanup",{},0,0],[[],"Reset",{},0,0]],[]];
SPLM.PartCleanup = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PartCleanup";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PartCleanup.CleanupParts = Object.freeze({
    "Work" : "Work", "Components" : "Components", "All" : "All"});

SPLM.PartCleanup.DeleteGroups = Object.freeze({
    "None" : "None", "Unnamed" : "Unnamed", "All" : "All"});

SPLM.PartCleanup.ResetComponentDisplayAction = Object.freeze({
    "No" : "No", "RemoveRedundantChanges" : "RemoveRedundantChanges", "RemoveAllChanges" : "RemoveAllChanges"});

export default SPLM;